<template>
    <div class="about">
        <MainHeader/>
        <MainLogo/>
        <section style="background: #fff">
	   
       <div class="container margin_60_35">
            <div class="row" id="contacts">
                
                <div class="col-md-6 col-sm-12 col-md-offset-3">
                    <div class="box_style_2" style="background: #f1f1f1">
                        <h2 class="inner">Restaurant Support</h2>
                        <p class="add_bottom_30" style="line-height: 2">Shop 2, Bligh Park Shopping Center,<br>
                        6 Colonial Drive, Bligh Park NSW 2756</p>
                        <p ><a href="tel:0245720884" class="phone" style="color: #404040"><i class="icon-phone-circled"></i>  0245720884</a></p>
                        <p class="nopadding"><a href="mailto:info@arturospizza.com.au" style="color: #404040"><i class="icon-mail-3"></i> info@arturospizza.com.au</a></p>
                    </div>
                </div>
            </div><!-- End row -->
        </div>
            
            
	   </section>   
    <PopUP/>
    <MainFooter/>

    </div>
     
</template>

<script>
import PreLoader from '@/components/PreLoader.vue'
import MainHeader from '@/components/MainHeader.vue'
import MainLogo from '@/components/MainLogo.vue'
import PopUP from '@/components/Popup.vue'
import MainFooter from '@/components/MainFooter.vue'
export default {
    name: 'privacyPolicy',
     components: {
        PreLoader,
        MainHeader,
        MainLogo,
        PopUP,
        MainFooter
    },
}
</script>

<style scoped>

</style>